module.exports = __webpack_public_path__ + "static/media/rainfall_alert.0370344d.png";